
export const PROTOCOL_ID = '/multistream/1.0.0'

// Conforming to go-libp2p
// See https://github.com/multiformats/go-multistream/blob/master/multistream.go#L297
export const MAX_PROTOCOL_LENGTH = 1024
